module.exports = __webpack_public_path__ + "static/media/identity-linvitation-promotion.d318a357.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/identity-linvitation-promotion.jpg
// module id = 255
// module chunks = 0